import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface praharState {
  currentPrahar: string;
  praharColor: string;
  desktopVideoUrl: string;
  mobileVideoUrl: string;
  praharTextColor: string;
  technicalName?: string;
  technicalNameHindi?: string;
  description?: string;
}

const initialState: praharState = {
  currentPrahar: '',
  praharColor: '',
  desktopVideoUrl: '',
  mobileVideoUrl: '',
  praharTextColor: '',
  technicalName: '',
  technicalNameHindi: '',
  description: '',
};

export const praharSlice = createSlice({
  name: 'currentPrahar',
  initialState,
  reducers: {
    setPrahar: (state, action) => {
      const { currentPrahar } = action.payload;
      // console.log('udpating prahar to => ', currentPrahar);
      state.currentPrahar = currentPrahar;
    },
    setPraharData: (state, action) => {
      const { technicalName, technicalNameHindi, description } = action.payload;
      if (technicalName !== undefined) state.technicalName = technicalName;
      if (technicalNameHindi !== undefined)
        state.technicalNameHindi = technicalNameHindi;
      if (description !== undefined) state.description = description;
    },
    setColor: (state, action) => {
      const { praharColor } = action.payload;
      state.praharColor = praharColor;
    },
    setDesktopVideoUrl: (state, action) => {
      const { desktopVideoUrl } = action.payload;
      state.desktopVideoUrl = desktopVideoUrl;
    },
    setMobileVideoUrl: (state, action) => {
      const { mobileVideoUrl } = action.payload;
      state.mobileVideoUrl = mobileVideoUrl;
    },
    setPraharTextColor: (state, action) => {
      const { praharTextColor } = action.payload;
      state.praharTextColor = praharTextColor;
    },
  },
});

export const {
  setPrahar,
  setPraharData,
  setColor,
  setDesktopVideoUrl,
  setMobileVideoUrl,
  setPraharTextColor,
} = praharSlice.actions;
export const currentPraharSelector = (state: RootState) =>
  state.prahar.currentPrahar;

export const praharColorSelector = (state: RootState) =>
  state.prahar.praharColor;

export const desktopVideoUrlSelector = (state: RootState) =>
  state.prahar.desktopVideoUrl;

export const mobileVideoUrlSelector = (state: RootState) =>
  state.prahar.mobileVideoUrl;

export const praharTextColorSelector = (state: RootState) =>
  state.prahar.praharTextColor;

export const technicalNameSelector = (state: RootState) =>
  state.prahar.technicalName;

export const technicalNameHindiSelector = (state: RootState) =>
  state.prahar.technicalNameHindi;

export const praharDescriptionSelector = (state: RootState) =>
  state.prahar.description;

export default praharSlice.reducer;
